




























































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';
import { exportFiles, exportPostFiles, formatUrl} from '../common/util';
import config from '../config/index';
import {mapState, mapActions} from 'vuex';
import store from '../store/store';
import { Form } from 'element-ui';
import {
  TaskData
} from '../types/common';
import { CheckInfoData, CheckFile } from '../types/checkInfo';

declare var _hmt: any;

export default Vue.extend({
  name: 'CheckResult',
  data(): CheckInfoData {
    return {
      listLoading: false,
      pageObj: {
        total: 100,
        pageIndex: 1,
        pageSize: 10
      },
      pageSizeList: [10, 20, 50, 100],
      isShowReportType: false,
      reportType: 'simple',
      pickerOption: {
        disabledDate(time: Date) {
          return time.getTime() > Date.now();
        }
      },
      isSearchSimple: true,
      isShowOrder: false,
      isShowMark: false,
      searchData: {
        beginPercent: '', // 开始相似比
        endPercent: '', // 结束相似比
        beginTime: '', // 开始检测时间
        endTime: '', // 结束检测时间
        CheckDBType: '', // 检测类型
        author: '', // 作者
        title: '', // 题名/文件夹
        checkState: '', // 检测状态
        isTroublePaper: '', // 标记
        taskName: '', // 文件夹id
        offset: 0, // 分页偏移量
        limit: 10, // 分页大小
        orderBy: '1', // 排序
        isSearchSubAccount: false, // 是否是子账户检测查询
        subUserId: '' // 子账户id
      },
      selectCheckResultList: [],
      checkIds: [],
      taskList: [],
      isAddFolder: true,
      copyCheckResultList: [],
      isShowForm: false,
      $refs: {
        form: Form
      },
      form: {
        newTask: '',
        taskId: '',
        taskName: ''
      },
      rules: {
        newTask: [{
          required: true,
          validator: async (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请输入文件夹名称'));
            } else if (value.length > 50) {
              callback(new Error('文件夹名称不能大于50位'));
            } else if (await (this as any).checkTaskName()) {
              callback(new Error('该文件夹已存在'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        taskId: [{
          required: true,
          validator: (rule: any, value: any, callback: any) => {
            if (value === '') {
              callback(new Error('请选择文件夹'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
      // checkResultObj: {
      //   data: [],
      //   total: 0
      // }
    };
  },
  computed: mapState({
    userInfo: (state: any) => store.getters.getUserInfo,
    tableHeader: (state: any) => store.getters.getTableHeader,
    checkResultList: (state: any) => store.getters.getCheckResult,
    checkHomeUrl: (state: any) => store.getters.getCheckHomeUrl,
    isShowIntro: (state: any) => store.getters.getIntro
  }),
  watch: {
    isShowIntro(newVal) {
      if (newVal && (this.checkResultList.length === 0)) {
        this.$store.dispatch('setCheckResult', [{
          author: '张伟',
          checkCost: 16,
          checkId: '',
          checkState: 'Success',
          checkTime: '2019/7/4 16:46:43',
          checkType: 'NPCheck',
          copyPercent: '21.68',
          isTroublePaper: false,
          reportUrl: {},
          subUserId: 'jacheck.',
          taskName: '2019年教职工发表',
          title: '待发表的期刊论文',
          userName: 'jacheck'
        }]);
      } else {
        this.getCheckResult();
      }
    }
  },
  methods: {
    // 查看在线报告
    getOnLineReportLink(row: any) {
      const checkTypeTable: any = {
        WFDB: 'JA',
        OneByOne: 'JAYD'
      };
      if(row.checkType === "OneByOne"){
          window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&checkType=OneByOne`, '_blank');
      } else {
          window.open(`${this.checkHomeUrl}reportweb/?reportId=${row.checkId}&productId=${checkTypeTable[row.checkType]}&reportType=originalText`, '_blank');
      }
    },
    // 校验查询条件是否正确
    checkSearchData() {
      if (this.searchData.beginPercent && !(/^[0-9]+[\.]?[0-9]*$/.test(this.searchData.beginPercent)) || this.searchData.endPercent && !(/^[0-9]+[\.]?[0-9]*$/.test(this.searchData.endPercent))) {
        this.$alert(' 请输入正确相似比！', '提示');
        return false;
      }
      if (this.searchData.beginPercent > 100 || this.searchData.endPercent > 100) {
        this.$alert(' 相似比不能大于100！', '提示');
        return false;
      }
      if (this.searchData.beginPercent && this.searchData.endPercent && (parseFloat(this.searchData.beginPercent) > parseFloat(this.searchData.endPercent))) {
        this.$alert(' 最小相似比不能大于最大相似比！', '提示');
        return false;
      }
      if (this.searchData.beginTime > this.searchData.endTime) {
        this.$alert(' 开始时间不能大于结束时间！', '提示');
        return false;
      }
      return true;
    },
    // 查询类型变化
    changeSearchType() {
      // const isSearchSimple = this.isSearchSimple;
      this.isSearchSimple = !this.isSearchSimple;
      // 记录用户操作
      // localStorage.setItem('isSearchSimple', isSearchSimple.toString());
      let scrollTop = 246;
      if (this.isSearchSimple) {
        scrollTop = 246;
      } else {
        scrollTop = 486;
      }
      this.$store.dispatch('setTableHeader', {
        scrollTop
      });
    },
    // 检测时间发生变化时触发
    changeTime() {
      // 日期转成字符串比较
      // this.searchData.beginTime = new Date(this.searchData.beginTime).toJSON();
      // this.searchData.endTime = new Date(this.searchData.endTime).toJSON();
    },
    // 排序变化触发
    changeOrder(order: string) {
      // 事件追踪start
      switch (order) {
        case '1':
          _hmt.push(['_trackEvent', '我的检测-检测信息', '检测时间降序', '事件价值', 1]);
          break;
        case '2':
          _hmt.push(['_trackEvent', '我的检测-检测信息', '检测时间升序', '事件价值', 1]);
          break;
        case '3':
          _hmt.push(['_trackEvent', '我的检测-检测信息', '相似比降序', '事件价值', 1]);
          break;
        case '4':
          _hmt.push(['_trackEvent', '我的检测-检测信息', '相似比升序', '事件价值', 1]);
          break;
      }
      // end
      this.searchData.orderBy = order;
      this.getCheckResult();
    },
    handleTableSort(e: any) { 
      if(e.prop === 'checkTime' && e.order === 'descending') { this.changeOrder('1'); }
      else if(e.prop === 'checkTime' && e.order === 'ascending') { this.changeOrder('2'); }
      else if(e.prop === 'copyPercent' && e.order === 'descending') { this.changeOrder('3'); }
      else if(e.prop === 'copyPercent' && e.order === 'ascending') { this.changeOrder('4'); }
      else if(e.prop === 'checkCostCount' && e.order === 'descending') { this.changeOrder('5'); }
      else if(e.prop === 'checkCostCount' && e.order === 'ascending') { this.changeOrder('6'); }
    },
    // 设置检测时间
    setCheckTime(num: any, type: string) {
      this.searchData.endTime = moment(new Date()).format('YYYY-MM-DD');
      this.searchData.beginTime = moment(this.searchData.endTime).subtract(num, type).format('YYYY-MM-DD');
      this.getCheckResult();
    },
    // 获取文件夹列表
    getTaskList() {
      this.$http.get('/api/Folder/FolderList').then((data: any) => {
        this.taskList = data.result;
      });
    },
    // 清空查询条件
    clear() {
      this.searchData = {
        beginPercent: '', // 开始相似比
        endPercent: '', // 结束相似比
        beginTime: '', // 开始检测时间
        endTime: '', // 结束检测时间
        CheckDBType: '', // 检测类型
        author: '', // 作者
        title: '', // 题名/文件夹
        checkState: '', // 检测状态
        isTroublePaper: '', // 标记
        taskName: '', // 文件夹id
        offset: 0, // 分页偏移量
        limit: 10, // 分页大小
        orderBy: '1', // 排序
        isSearchSubAccount: false, // 是否是子账户检测查询
        subUserId: '' // 子账户id
      };
      this.searchData.endTime = moment().format('YYYY-MM-DD');
      this.searchData.beginTime = moment(this.searchData.endTime).subtract(7, 'day').format('YYYY-MM-DD');
      this.getCheckResult();
    },
    gotoSearch() {
      this.pageObj.pageIndex = 1;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 获取检测结果
    getCheckResult() {
      const isCanSearch = this.checkSearchData();
      if (!isCanSearch) {
        return false;
      }
      this.listLoading = true;
      this.$http.get('/api/Check/CheckResultList', {
        params: this.searchData
      }).then((data: any) => {
        // this.checkResultObj = res.data;
        this.$store.dispatch('setCheckResult', data.result);
        // this.checkResultList = data.result;
        this.pageObj.total = data.total;
        this.$nextTick(() => {
          this.listLoading = false;
          this.initFixTable();
        });
      });
    },
    // 查看在线报告
    checkReport(url: string) {
      window.open(url, '_blank');
    },
    // 导出
    exportCheckResult() {
      // 事件追踪start
      _hmt.push(['_trackEvent', '我的检测-检测信息', '检测信息列表导出', '事件价值', 1]);
      // end
      const isCanSearch = this.checkSearchData();
      if (!isCanSearch) {
        return false;
      }
      exportFiles(formatUrl(this.searchData, `${config.api}/api/Check/Export/CheckResultList`));
    },
    // 选择、取消上传文件钩子方法
    handleSelectionChange(val: CheckFile[]) {
      this.selectCheckResultList = val;
      this.checkIds = [];
      _.forEach(this.selectCheckResultList, (value: CheckFile) => {
        this.checkIds.push(value.checkId);
        // 同步两个列表状态
        (this.$refs.copyList as any).toggleRowSelection(value, true);
        (this.$refs.checkResultList as any).toggleRowSelection(value, true);
      });
      // 同步两个列表状态
      if (this.checkIds.length === 0) {
        (this.$refs.copyList as any).clearSelection();
        (this.$refs.checkResultList as any).clearSelection();
      }
    },
    // 显示/隐藏选择报告类型
    showReportType(val: boolean) {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      if (val && this.checkIds.length > 50) {
        this.$alert(' 检测报告文件较大，建议每次下载报告不超过50篇 ', '提示');
        return false;
      }
      const isCanDownload = _.some(this.selectCheckResultList, (item: CheckFile) => {
        return item.checkState !== 'Success';
      });
      if (isCanDownload) {
        this.$alert('只有检测成功文献才可以下载，请重新选择！', '提示');
        return false;
      }

      let oneList = this.selectCheckResultList.filter((item: any) => item.checkType === "OneByOne");
      let wfList = this.selectCheckResultList.filter((item: any) => item.checkType === "WFDB");
      if(oneList.length && wfList.length) {
        this.isShowReportType = false;
        this.$alert('您选中的检测信息包含万方全库比对和一对一比对类型，两种检测类型提供的检测报告不同，建议同检测类型批量下载！', '提示');
        return false;
      }
      this.reportType = oneList.length ? 'detailPart' : 'simple';
      this.isShowReportType = val;
    },
    // 改变添加文件夹表单状态
    changeFormState(state: boolean) {
      if (this.checkIds.length === 0 && state) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      // if (this.taskList.length === 0 && state) {
      //   this.$alert('暂无文件夹，您可在文件夹管理页面进行创建', '提示');
      //   return false;
      // }
      if (!state) {
        this.$refs.form.resetFields();
      }
      !this.taskList.length ? this.isAddFolder = false : '';
      this.isShowForm = state;
    },
    // 改变文件夹类型事件
    changeFolderType() {
      this.$refs.form.resetFields();
    },
    // 已有文件夹change事件
    changeTask(id: string) {
      let obj: TaskData | any = {};
      obj = this.taskList.find((item: TaskData) => {
        return item.taskId === id;
      });
      this.form.taskName = obj && obj.taskName || '';
    },
    // 检测文件夹名称是否存在
    async checkTaskName() {
      return this.$http.put(`/api/Folder/IsExist/${this.form.newTask}`).then((data: any) => data.result);
    },
    // 创建文件夹
    createFolder() {
      // 事件追踪start
      _hmt.push(['_trackEvent', '我的检测-检测信息', '添加至文件夹', '事件价值', 1]);
      // end
      this.$http.post(`/api/Folder/Create`, {
        folderName: this.form.newTask
      }).then(async (data: any) => {
        const result = data.result;
        Object.assign(this.form, {
          taskId: result.item1,
          taskName: result.item2
        });
        this.isAddFolder = true;
        await this.getTaskList();
        this.setInTask();
      }).catch(() => {
        this.$store.dispatch('setLoading', {
          isShow: false
        });
      });
    },
    // 添加至文件夹
    intoFolder() {
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          this.$store.dispatch('setLoading', {
            isShow: true
          });
          if (!this.isAddFolder) {
            this.createFolder();
          } else {
            this.setInTask();
          }
        }
      });
    },
    // 添加至文件夹
    setInTask() {
      this.$refs.form.validate((valid: any) => {
        if (valid) {
          Object.assign(this.form, {
            checkIds: this.checkIds
          });
          // 事件追踪start
          _hmt.push(['_trackEvent', '我的检测-检测信息', '添加至文件夹', '事件价值', 1]);
          // end
          this.$http.put('/api/Check/AddToFolder', this.form).then((res: any) => {
            this.$store.dispatch('setLoading', {
              isShow: false
            });
            this.$message({
              message: `添加成功`,
              type: 'success'
            });
            this.getCheckResult();
            this.changeFormState(false);
          }).catch(() => {
            this.$store.dispatch('setLoading', {
              isShow: false
            });
          });
        }
      });
    },
    // 删除选中文件
    delFileList() {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      this.$confirm('检测信息删除后将无法恢复，是否确认删除？', '提示', { type: 'warning' }).then(() => {
        this.$store.dispatch('setLoading', {
          isShow: true
        });
        // 事件追踪start
        _hmt.push(['_trackEvent', '我的检测-检测信息', '删除', '事件价值', 1]);
        // end
        this.$http.delete('/api/Check/Delete/CheckResult', {
          data: {
            checkIds: this.checkIds
          }
        }).then((data: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
          this.handleSelectionChange([]);
          this.getCheckResult();
          this.$message({
            message: `删除成功`,
            type: 'success'
          });
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 重新检测
    reCheck(checkId?: string) {
      if (!checkId) {
        if (this.checkIds.length === 0) {
          this.$alert(' 请至少选择一条检测信息！', '提示');
          return false;
        }
        const isCanReCheck = _.some(this.selectCheckResultList, (item: CheckFile) => {
          return item.checkState === 'Success' || item.checkState === 'Checking';
        });
        if (isCanReCheck) {
          this.$alert('您选中的检测信息中存在状态为等待检测或检测成功的，请重新选择后再开始检测！', '提示');
          return false;
        }
        this.$store.dispatch('setLoading', {
          isShow: true,
          text: '正在重检...'
        });
        this.$http.post('/api/Check/ReCheck', {
          checkIds: this.checkIds
        }).then((res: any) => {
          this.$store.dispatch('setLoading', {
            isShow: false,
            text: '正在加载...'
          });
          this.$message({
            message: `重检成功`,
            type: 'success'
          });
          this.getCheckResult();
        }).catch(() => {
          this.$store.dispatch('setLoading', {
            isShow: false,
            text: '正在加载...'
          });
        });
      } else {
        this.$http.post('/api/Check/ReCheck', {
          checkIds: [checkId]
        }).then((res: any) => {
          this.$message({
            message: `重检成功`,
            type: 'success'
          });
          this.getCheckResult();
        });
      }
    },
    // 标记/取消问题文献
    signPaper(mark: boolean) {
      if (this.checkIds.length === 0) {
        this.$alert(' 请至少选择一条检测信息！', '提示');
        return false;
      }
      const params = Object.assign({
        isTroublePaper: mark
      }, {
        checkIds: this.checkIds
      });
      // 事件追踪start
      if (mark) {
        _hmt.push(['_trackEvent', '我的检测-文献送检', '标记', '事件价值', 1]);
      }
      // end
      this.$http.patch('/api/Check/SetTroublePaper', params).then((res: any) => {
        this.$message({
          message: `操作成功`,
          type: 'success'
        });
        this.getCheckResult();
      });
    },
    // 下载报告
    download() {
      this.$message({
        message: `正在下载报告，请稍等！`,
        type: 'success'
      });
      const isSingle = this.checkIds.length === 1;
      this.$http.post('/api/Report/Download/Reports', {
        reportType: this.reportType,
        checkIds: this.checkIds,
        checkType: this.selectCheckResultList[0].checkType
      }, {
        responseType: 'blob'
      }).then((res: any) => {
        let fileName = '';
        let headerFileName = res.headers['content-disposition'].split('filename*=UTF-8\'\'')[1];
        headerFileName = decodeURIComponent(headerFileName);
        console.log(headerFileName);
        if (isSingle) {
          switch (this.reportType) {
            case 'simple':
              fileName = `${this.selectCheckResultList[0].title}(简明报告).pdf`;
              break;
            case 'originalText':
              fileName = `${this.selectCheckResultList[0].title}(原文标注报告).pdf`;
              break;
            case 'detailPart':
              fileName = `${this.selectCheckResultList[0].title}(详细片段报告).pdf`;
              break;
            default:
              fileName = `${this.selectCheckResultList[0].title}(原文标注报告).pdf`;
              break;
          }
        } else {
          switch (this.reportType) {
            case 'simple':
              fileName = `“${moment().format('YYYYMMDDHHmmss')}”论文相似性检测简明报告.zip`;
              break;
            case 'originalText':
              fileName = `“${moment().format('YYYYMMDDHHmmss')}”论文相似性检测原文标注报告.zip`;
              break;
            case 'detailPart':
              fileName = `“${moment().format('YYYYMMDDHHmmss')}”论文相似性检测详细片段报告.zip`;
              break;
            default:
              fileName = `“${moment().format('YYYYMMDDHHmmss')}”论文相似性检测原文标注报告.zip`;
              break;
          }
        }
        if (headerFileName) {
          fileName = headerFileName;
        }
        // post导出方法
        exportPostFiles(res.data, fileName);
      });
      // exportFiles(formatUrl({reportType: this.reportType}, `${config.api}/api/Report/Download/Reports/${this.checkIds}`));
      this.isShowReportType = false;
    },
    // 改变分页size
    handleSizeChange(val: number) {
      this.pageObj.pageSize = val;
      this.pageObj.pageIndex = 1;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 改变当前页
    handleCurrentChange(val: number) {
      this.pageObj.pageIndex = val;
      this.setSearchPage();
      this.getCheckResult();
    },
    // 设置分页
    setSearchPage() {
      this.searchData.offset = (this.pageObj.pageIndex - 1) * this.pageObj.pageSize;
      this.searchData.limit = this.pageObj.pageSize;
    },
    // 初始化固定表头
    initFixTable() {
      // 函数节流
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.$refs.fixTableStyle) {
          (this.$refs.fixTableStyle as any).style.width = (this.$refs.tableStyle as any).clientWidth + 'px';
        }
      }, 200);
    }
  },
  mounted() {
    window.onresize = () => {
      this.initFixTable();
    };
    this.$store.dispatch('setTableHeader', {
      scrollTop: 246
    });
    // 获取用户操作
    // this.isSearchSimple = localStorage.getItem('isSearchSimple') !== 'true';
    this.searchData.taskName = decodeURIComponent((this.$route.query as any).taskName || '');
    if (this.searchData.taskName) {
      this.isSearchSimple = false;
    } else {
      this.searchData.endTime = moment().format('YYYY-MM-DD');
      this.searchData.beginTime = moment(this.searchData.endTime).subtract(7, 'day').format('YYYY-MM-DD');
    }
    this.getCheckResult();
    this.getTaskList();
  }
});
